import Box from '@eversports/klimt-primitives/legacy/Box'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Snackbar from '@eversports/klimt-primitives/legacy/Snackbar'

import CloseIcon from '../../assets/icons/close.svg'
import { Localized } from '../../localization/react'

interface Props {
  open: boolean
  setIsOpen: (value: boolean) => void
}

const MapSnackbar = (props: Props) => {
  const { open, setIsOpen } = props

  const handleClose = () => setIsOpen(false)

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      message={<Localized id="map-geolocation-not-found-error-message" />}
      action={
        <Box sx={{ cursor: 'pointer' }} onClick={handleClose}>
          <Icon src={CloseIcon} size="default" color="white" />
        </Box>
      }
    />
  )
}

export default MapSnackbar
